function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.88,17.463h5.436a1.029,1.029,0,0,0,1.127-1.134v-.122c0-1.591-1.662-3.253-2.506-4.084a.85.85,0,0,1,0-1.327c.844-.837,2.506-2.493,2.506-4.09V6.6a1.034,1.034,0,0,0-1.127-1.14H9.88A1.037,1.037,0,0,0,8.753,6.6v.1c0,1.6,1.668,3.253,2.512,4.09a.85.85,0,0,1,0,1.327c-.844.831-2.512,2.493-2.512,4.084v.122A1.032,1.032,0,0,0,9.88,17.463Zm.541-1a.3.3,0,0,1-.174-.528L12.257,14a.452.452,0,0,1,.689,0l2,1.932a.294.294,0,0,1-.174.528Z",
  transform: "translate(-8.753 -5.463)"
});

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.691 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.8d10149a.svg";
export { ForwardRef as ReactComponent };